import React from "react";
import ShowcaseView, { DEFAULT_HEADLINE } from "@/components/ShowcaseView";
import { previewItemsOf } from "./showcaseManagerModel";

const ShowcaseManagerPreview = ({ showcase, brokerageName, logoUrl, items, mode }) => (
  <section className="showcase-manager__preview" aria-label="Preview of your website showcase">
    <div className="showcase-manager__browser" aria-hidden="true">
      <span />
      <span />
      <span />
      <em>{showcase?.sites?.[0]?.host || "yourbrokerage.com"}</em>
    </div>
    <div className="showcase-manager__preview-body">
      <ShowcaseView
        preview
        brokerage={{ name: brokerageName, logoUrl }}
        headline={showcase?.headline || DEFAULT_HEADLINE}
        items={previewItemsOf(items, mode)}
        sort="featured"
      />
    </div>
  </section>
);

export default ShowcaseManagerPreview;
